import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "web-editor" }
const _hoisted_2 = { class: "edit-draft" }
const _hoisted_3 = { class: "editor-header" }
const _hoisted_4 = { class: "right-box" }
const _hoisted_5 = { class: "status-text with-padding" }
const _hoisted_6 = { class: "md-editor" }

import { onMounted, reactive, toRefs, markRaw, ref } from "vue";

import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import axiosInstance from "@/utils/axiosInstance";

import { Viewer } from "@bytemd/vue-next";

import gfm from "@bytemd/plugin-gfm";
import "bytemd/dist/index.css";

// 突出显示代码块
import highlight from "@bytemd/plugin-highlight";
import "highlight.js/styles/default.css";

// 对齐方式
import alignPlugin from "bytemd-plugin-align";
// 主题
import theme from "bytemd-plugin-theme";
// 解析前言 格式化
import frontmatter from "@bytemd/plugin-frontmatter";
// 表情
import gemoji from "@bytemd/plugin-gemoji";

// 代码高亮
import highLightPlugin from "bytemd-plugin-highlight";
// 图片的缩放
import imagePlugin from "bytemd-plugin-image";
// 代码复制
import copyCode from "bytemd-plugin-copy-code";
import "bytemd-plugin-copy-code/dist/style/index.css";

// 缩放图片 点击图片放大,再点击缩小
import mediumZoom from "@bytemd/plugin-medium-zoom";
// 图表
import mermaid from "@bytemd/plugin-mermaid";
import mermaidLocale from "@bytemd/plugin-mermaid/locales/zh_Hans.json";
// 数学公式插件
import math from "@bytemd/plugin-math";
import mathLocale from "@bytemd/plugin-math/locales/zh_Hans.json";
import "katex/dist/katex.css";

import zhHans from "bytemd/locales/zh_Hans.json";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";

import type { FormInstance, FormRules } from "element-plus";

const formLabelWidth = "83px";

// 插件
interface RuleForm {
  article_id: string;
  audit_status: Number;
  article_level: Number;
  is_hot: Number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PostReviewAction',
  setup(__props) {

const SSRData = ref({
  title: "",
  description: "",
  keywords:
    "宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

const pluginsList = [
  gfm(),
  math({
    locale: mathLocale,
  }),
  alignPlugin(),
  highLightPlugin(),
  imagePlugin(),
  copyCode({
    copySuccess: (text) => {
      console.log(text);
      ElMessage.success("代码复制成功");
    },
    copyError: (err) => {
      console.log(err);
    },
  }),
  mediumZoom(),
  mermaid({
    locale: mermaidLocale,
  }),
  highlight(),
  theme(),
  frontmatter(),
  gemoji(),
];

const router = useRouter();

// 编辑器数据初始化 1 未通过 2 待审核  3 通过
const state = reactive({
  value: "",
  plugins: markRaw(pluginsList),
  zh: zhHans,
  isempty: ref(true),
  dialogFormVisible: ref(false),
  auditstatus:[{text:'未通过',value:1},{text:'待审核',value:2},{text:'通过',value:3}]
});

const { value, plugins, zh, markDownRef } = toRefs(state);

//文章信息
const DetailInfo = reactive({
  article_id: "",
  title: "",
  info_content: "",
  category_id: "",
  category_name: "",
  brief_content: "",
  link_url: "",
  cover_image: "",
  comment_count: "",
  view_count: "",
  digg_count: "",
  favorited_count: "",
  is_markdown: "",
  is_hot: "",
  uuid: "",
  author: "",
  created_at: "",
  avatar_url: "",
});

onMounted(async () => {
  //获取文章ID 参数
  const postID = router.currentRoute.value.params.postID as string;
  fetchArticleInfoData(postID);
});

// 获取文章数据
const fetchArticleInfoData = async (postID: string) => {
  try {
    await axiosInstance
      .get("/api/HomeArticle/detail", {
        params: { article_id: postID },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          const articleData = result.data;
          DetailInfo.article_id = articleData.article_id;
          DetailInfo.title = articleData.title;
          DetailInfo.info_content = articleData.info_content;
          DetailInfo.category_id = articleData.category_id;
          DetailInfo.category_name = articleData.category_name;
          DetailInfo.brief_content = articleData.brief_content;
          DetailInfo.link_url = articleData.link_url;
          DetailInfo.cover_image = articleData.cover_image;
          DetailInfo.comment_count = articleData.comment_count;
          DetailInfo.view_count = articleData.view_count;
          DetailInfo.digg_count = articleData.digg_count;
          DetailInfo.favorited_count = articleData.favorited_count;
          DetailInfo.is_markdown = articleData.is_markdown;
          DetailInfo.is_hot = articleData.is_hot;
          DetailInfo.uuid = articleData.uuid;
          DetailInfo.author = articleData.author;
          DetailInfo.avatar_url = articleData.avatar_url;
          DetailInfo.created_at = articleData.created_at;
          state.value = articleData.info_content;
          //SEO 内容
          SSRData.value.title = articleData.title + " - " + WebSite_Name;
          SSRData.value.description = articleData.brief_content;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = "找不到页面";
          SSRData.value.description = "";
          SSRData.value.keywords = "";
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取文章数据失败");
  }
};

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};

//操作
const publishBtn = () => {
  state.dialogFormVisible = true;
};

const ruleFormRef = ref<FormInstance>();

const form = reactive<RuleForm>({
  article_id: "",
  audit_status: 1,
  article_level: 4,
  is_hot:0
});

const rules = reactive<FormRules<RuleForm>>({
   audit_status: [{ required: true, message: "请选择审核类型", trigger: "blur" }],
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      let params = {
        article_id: DetailInfo.article_id,
        audit_status:form.audit_status,
        article_level:form.article_level,
        is_hot:form.is_hot
      };

      axiosInstance
        .post("api/EditorialCheckList/AuditArticleSave", params)
        .then((res) => {
          var result = res.data;
          if (result.success) {
            router.push({ path: "/creator/postreview"});
          }
        });
    } else {
      console.log("error submit!");
    }
  });
};


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("header", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            placeholder: "输入文章标题...",
            spellcheck: "false",
            maxlength: "80",
            class: "title-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((DetailInfo.title) = $event))
          }, null, 512), [
            [_vModelText, DetailInfo.title]
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "topic-icon" }, null, -1)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(DetailInfo.author) + "   " + _toDisplayString(DetailInfo.created_at), 1),
            _createElementVNode("div", { class: "with-padding" }, [
              _createElementVNode("button", {
                class: "publish-btn",
                onClick: publishBtn
              }, " 操作 ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Viewer), {
          ref_key: "markDownRef",
          ref: markDownRef,
          locale: _unref(zh),
          value: _unref(value),
          plugins: _unref(plugins)
        }, null, 8, ["locale", "value", "plugins"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: state.dialogFormVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((state.dialogFormVisible) = $event)),
      title: "审核文章",
      width: "580"
    }, {
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "plusdivider" }, null, -1)),
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: form,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "分类",
              "label-width": formLabelWidth,
              prop: "audit_status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.audit_status,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.audit_status) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.auditstatus, (audit) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        key: audit.value,
                        value: audit.value,
                        border: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(audit.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "级别",
              "label-width": formLabelWidth,
              prop: "category_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input_number, {
                  modelValue: form.article_level,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.article_level) = $event)),
                  step: 1,
                  "step-strictly": ""
                }, null, 8, ["modelValue"]),
                _cache[8] || (_cache[8] = _createTextVNode("  信息流显示4级以上 "))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "推荐",
              "label-width": formLabelWidth,
              prop: "audit_status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.is_hot,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.is_hot) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_el_radio, {
                      key: 0,
                      value: 0,
                      border: ""
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("不推荐 ")
                      ])),
                      _: 1
                    })),
                    (_openBlock(), _createBlock(_component_el_radio, {
                      key: 1,
                      value: 1,
                      border: ""
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("推荐 ")
                      ])),
                      _: 1
                    }))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { class: "button-group-right" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode(" 确定 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (state.dialogFormVisible = false))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("取消")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})